const Kilian = {
    name: "Kilian",
    bpm: 116,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default Kilian;